export default "__VITE_ASSET__DBQJlA8n__"